import { Notification } from '@eds/vanilla';

class NotificationService {
  constructor() {}

  error(message) {
    const notification = new Notification({
      title: 'Error',
      description: message,
      icon: 'icon-fault',
      stripeColor: 'red',
      timeout: 5000,
    });

    notification.init();
  }

  success(message) {
    const notification = new Notification({
      title: 'Success',
      description: message,
      icon: 'icon-check',
      stripeColor: 'green',
      timeout: 5000,
    });

    notification.init();
  }

  warning(message) {
    const notification = new Notification({
      title: 'Warning',
      description: message,
      icon: 'icon-triangle-warning',
      stripeColor: 'yellow',
      timeout: 5000,
    });

    notification.init();
  }
}

export default new NotificationService();
